'use strict';
import isUndefined from 'lodash/isUndefined';
import {ORGANIZATION_CLASS_NAME, ORGANIZATION_COLLECTION} from './config';


export function toStringStatic(data) {
  return data ? data.name : null;
}

export function OrganizationDomainProvider() {
  return {
    $get: [
      '$injector',
      '$filter',
      'FirebaseUtil',
      'AuthService',
      'AbstractDomainClass',
      'AvatarMixin',
      'FirebaseQueueService',
      'fetchUtils',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function (
        $injector,
        $filter,
        FirebaseUtil,
        AuthService,
        AbstractDomainClass,
        AvatarMixin,
        FirebaseQueueService,
        fetchUtils,
        ROOT_API_COLLECTION,
        ROOT_API_SPEC,
      ) {
        const abbreviate = $filter('abbreviate');

        /**
         * @param {Object} data Serialized data
         * @class
         * @implements {HasMembersDomainClass}
         */
        function OrganizationDomain(data) {
          AbstractDomainClass.call(this, OrganizationDomain, data);
        }

        AbstractDomainClass.__inheritFrom(OrganizationDomain, ORGANIZATION_CLASS_NAME, ORGANIZATION_COLLECTION);

        OrganizationDomain.$constraints.addConstraints({
          name: {type: 'string'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          poc: {type: 'DomainLink', domainClass: 'PersonDomain', nullable: true}, //Point of Contact
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          // Override Camera Settings
          overrideCameraSettings: {type: 'boolean', nullable: true},
          cameraResolution: {type: 'number', nullable: true},
          jpgQuality: {type: 'number', nullable: true},
          vidQuality: {type: 'number', nullable: true},

          members: {type: 'DomainCollection', domainClass: 'UserDomain', relationClass: 'OrgMemberDomain'},
          invites: {type: 'DomainCollection', domainClass: 'OrganizationInviteDomain', link: 'organization'},
          personnel: {type: 'DomainCollection', domainClass: 'PersonDomain', link: 'organization', belongsTo: true},
          teamTypes: {type: 'DomainCollection', domainClass: 'TeamTypeDomain', link: 'organization', belongsTo: true},
          teams: {type: 'DomainCollection', domainClass: 'TeamDomain', link: 'organization', belongsTo: true},
          forms: {type: 'DomainCollection', domainClass: 'FormDomain', link: 'organization', belongsTo: true},
          projects: {type: 'DomainCollection', domainClass: 'ProjectDomain', link: 'organization', belongsTo: true},
          privateProjects: {
            type: 'DomainCollection',
            domainClass: 'ProjectDomain',
            link: 'organization',
            belongsTo: true
          },
          assets: {type: 'DomainCollection', domainClass: 'AssetDomain', link: 'organization', belongsTo: true},
          requirementTypes: {
            type: 'DomainCollection',
            domainClass: 'RequirementTypeDomain',
            link: 'organization',
            belongsTo: true
          },

          dataTags: {type: 'DomainCollection', domainClass: 'DataTagDomain', link: 'organization', belongsTo: true}
        });

        AvatarMixin(OrganizationDomain);

        // more methods go here;

        OrganizationDomain.prototype.getAvatarInitials = getAvatarInitials;

        OrganizationDomain.createOrgRequest = function createOrgRequest() {
          return {
            name: '',
            description: ''
          };
        };

        OrganizationDomain.prototype.changeRole = function (userId, role) {
          const request = {
            method: 'organizations/roles/change',
            organization: this.$id,
            targetUser: userId,
            role: role
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        OrganizationDomain.removeUser = function (orgId, userId, deleteAlias) {
          const params = isUndefined(deleteAlias) ? null : `?deleteAlias=${deleteAlias}`;
          const url = `${fetchUtils.API_URL}/api/organizations/${orgId}/members/${userId}${params ? '?' + params : ''}`;
          const request = {
            method: 'DELETE',
            mode: 'cors',
            cache: 'default'
          };

          return fetchUtils.requestWithAuth(url, request);
        };

        OrganizationDomain.prototype.removeUser = function (userId, deleteAlias) {
          return OrganizationDomain.removeUser(this.$id, userId, deleteAlias);
        };

        // TODO: add support for custom templates. these would presumably be saved against an org so you wouldn't need to pass this here
        OrganizationDomain.prototype.sendInvite = function sendInvite(name, email) {
          const request = {
            method: 'organization_invite',
            organization: this.$id,
            inviteeName: name,
            email: email
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        OrganizationDomain.prototype.toString = function () {
          return toStringStatic(this);
        };

        function getAvatarInitials() {
          return abbreviate(this.name);
        }

        return OrganizationDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/organizations/domain/OrganizationDomain.js